import type { CaptureContext } from '@sentry/core';
import * as Sentry from '@sentry/react';

export function captureException(error: Error, otherProps?: CaptureContext): void {
  Sentry.captureException(error, { level: 'error', ...otherProps });
}

export function captureMessage(message: string, otherProps?: CaptureContext): void {
  Sentry.captureMessage(message, { level: 'info', ...otherProps });
}
